export default "__VITE_ASSET__Rb2ROnRk__ 584w";